<template>
    <MainPage :isSearchList="true" :isSideMenu="false">
        <div class="search-body">
            <div class="sidebar-body">
                <div class="sidebar-header-text">
                    {{ lbl.searchList.sidebar.searchDetail }}
                </div>
                <div>
                    <Category
                        ref="category"
                        :categoryConfig="blobConfig.category_menu_config"
                        @changeCategory="changeFilter($event)"
                    ></Category>
                    <RangePrice
                        ref="rangePrice"
                        @changeRangePrice="changeFilter($event)"
                    ></RangePrice>
                    <Agency
                        v-if="blobConfig.show_agency"
                        ref="agency"
                        :categoryConfig="blobConfig.category_menu_config"
                        @changeAgency="changeAgency($event)"
                    ></Agency>
                </div>
            </div>
            <div class="content-item">
                <CampaignList
                    v-if="isInitCampaignConfig"
                    ref="campaign-list"
                    :blobConfig="blobConfig"
                    :lbl="lbl"
                    :isLoaded="isLoaded"
                    :initListConfig="campaignListConfig"
                    :initFilterConfig="campaginListFilterConfig"
                    :busEvent="busCampaign"
                    :query="query"
                    :modalController="modalController"
                    :dataFilter="dataFilter"
                    @clearSearch="clearSearch($event)"
                ></CampaignList>
            </div>
        </div>
    </MainPage>
</template>

<script>
import Vue from "vue";
// component
// import LayoutSearch from "../components/Layout/LayoutSearch.vue";
import MainPage from '@/components/Layout/Page/MainPage.vue';
import Category from "../components/Category/Category.vue";
import RangePrice from "../components/RangePrice/RangePrice.vue";
import Agency from "../components/Agency/Agency.vue";
import CampaignList from "../components/CampaignList/CampaignList.vue";
// helper
import Account from "@/helper/AccountHelper.js";
import Locale from "@/helper/locale/Locale.js";
// service
import { CampaignListConfigBuilder, CampaignListFilterConfigBuilder } from "@/core/Campaign/model/CampaignConfigModel.js";
// modal
import ModalFactory from "../components/Modal/ModalFactory.js";

export default {
    components: {
        // LayoutSearch,
        MainPage,
        Category,
        RangePrice,
        Agency,
        CampaignList
    },
    data() {
        return {
            lbl: Locale.getLbl(),
            blobConfig: Account.getCacheBlob(),
            query: Account.getCacheQuery(),
            isInit: false,
            listConfig: {},
            campaignListConfig: {},
            campaginListFilterConfig: {},
            isInitCampaignConfig: false,
            isFlashSale: false,
            isBeginCampaign: false,
            isLoaded: false,
            busCampaign: new Vue(),

            modalFactory: new ModalFactory(),
            modalController: null,

            min: 0,
            max: 999999,
            campaignFilter: {},
            agencyFilter: {}
        }
    },
    created: function() {
        this.initialModal();
        // this.initLanding();
        // this.initialLoadMore();
        // this.initialCampaign()
    },
    computed: {
        dataFilter() {
            let result = {
                min: this.min,
                max: this.max,
                campaignFilter: this.campaignFilter,
                agencyFilter: this.agencyFilter,
            }
            // console.log(`🚀 ~ file: SearchPage.vue:109 ~ dataFilter ~ result:`, result)
            return result
        }
    },
    mounted () {
        // console.log('this.blobConfig', this.blobConfig)
    },
    methods: {
        initialModal: function () {
            this.alertModal = this.modalFactory.getAlertModal();
            this.loadingModal = this.modalFactory.getLoadingModal();
            this.addToCartModal = this.modalFactory.getAddToCartModal();
            this.campaignModal = this.modalFactory.getCampaignModal();
            this.modalController = this.modalFactory.getModalController();

        },
        changeFilter: function (params) {
            if(params?.length === 2) {
                this.min = params[0]
                this.max = params[1]
            }else if(params !== undefined){
                this.campaignFilter = params
            }
            if(Object.keys(this.campaignFilter).length > 0){
                this.initialCampaign(this.campaignFilter);
            }
        },
        changeAgency: function (agency) {
            var objAgency = {
                list_config: agency.list_config,
                agencyid: agency.id
            }
            this.agencyFilter = agency
            this.initialCampaign(objAgency);
        },
        initialCampaign: function (objConfigCampaign) {
            // this.campaignListConfig = {};
            // this.campaginListFilterConfig = {};

            var listConfig = new CampaignListConfigBuilder()
                .setConfigList(objConfigCampaign.list_config)
                .setSeeMore(false);

            this.campaignListConfig['strConfigList'] = 'campaign_b2b_marketplace'
            if (this.campaignFilter.id) {
                listConfig.setCatId(this.campaignFilter.id);
                this.campaignListConfig = listConfig.create()
            }
            // init
            if(!objConfigCampaign.id && !objConfigCampaign.agencyid) {
                this.campaignListConfig = listConfig.create()
            }

            var filterConfig = new CampaignListFilterConfigBuilder();
            // console.log(`🚀 ~ file: SearchPage.vue:144 ~ filterConfig:`, filterConfig)
            if (objConfigCampaign.agencyid) {
                filterConfig.setLocationAgency(objConfigCampaign.agencyid);
                // this.campaginListFilterConfig = filterConfig.create()
            }

            this.campaginListFilterConfig = filterConfig.create()

            filterConfig.setMinPrice(this.min)
            filterConfig.setMaxPrice(this.max)
            this.campaginListFilterConfig['intMinPrice'] = this.min
            this.campaginListFilterConfig['intMaxPrice'] = this.max

            this.isInitCampaignConfig = true;

            this.busCampaign.$emit('reInitList', {
                listConfig: this.campaignListConfig,
                filterConfig: this.campaginListFilterConfig,
            });
            // console.log(`🚀 ~ file: SearchPage.vue:173 ~ this.campaignListConfig:`, this.campaignListConfig)
            // console.log(`🚀 ~ file: SearchPage.vue:173 ~ this.campaginListFilterConfig:`, this.campaginListFilterConfig)
            // console.log(`🚀 ~ file: SearchPage.vue:167 ~ this.busCampaign:`, this.busCampaign)
            setTimeout(()=> {
                if (this.isBeginCampaign && this.query.campaignId) {
                    this.busCampaign.$emit("initCampaignDetail");
                    this.isBeginCampaign = false;
                }
            },500);
        },
        clearSearch: function(clear) {
            // console.log(`🚀 ~ file: SearchPage.vue:189 ~ clear:`, clear)
            console.log('clearSearch')
            switch(clear) {
                case 'all':
                    this.$refs.category.clearValue()
                    this.$refs.rangePrice.clearValue()
                    this.$refs.agency.clearValue()
                    break;
                case 'category':
                    this.$refs.category.clearValue()
                    break;
                case 'rangePrice' :
                    this.$refs.rangePrice.clearValue()
                    break;
                case 'agency' :
                    this.$refs.agency.clearValue()
                    break;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../../style/base/base.scss';
@import './SearchPage.scss';
</style>
